import { createReducer } from 'redux-act';
import {
  clearRecommendedPropertyAvailability,
  fetchRecommendedPropertyAvailabilityFailure,
  fetchRecommendedPropertyAvailabilitySuccess,
  setLoading,
} from './recommendedPropertyActions';

const initialState = {
  isLoading: false,
  results: [],
};

export const reducer = createReducer(
  {
    [clearRecommendedPropertyAvailability]: (state) => ({ ...state, results: [], error: null }),
    [fetchRecommendedPropertyAvailabilityFailure]: (state, error) => ({ ...state, error, results: [] }),
    [fetchRecommendedPropertyAvailabilitySuccess]: (state, results) => ({ ...state, error: null, results }),
    [setLoading]: (state, isLoading) => ({ ...state, isLoading }),
  },
  initialState,
);
